var exports = {
  "Ur": "VoiceMessageRecorder.module__voiceButtonWrapper___TEU5b2",
  "VK": "VoiceMessageRecorder.module__voiceButton___TEU5b2",
  "qu": "VoiceMessageRecorder.module__voiceButtonIcon___TEU5b2",
  "hB": "VoiceMessageRecorder.module__holdTooltip___TEU5b2",
  "Yh": "VoiceMessageRecorder.module__recordingOverlay___TEU5b2",
  "Zo": "VoiceMessageRecorder.module__overlayInner___TEU5b2",
  "kK": "VoiceMessageRecorder.module__recordingControls___TEU5b2",
  "PJ": "VoiceMessageRecorder.module__recordingBar___TEU5b2",
  "lL": "VoiceMessageRecorder.module__recordingDot___TEU5b2",
  "O1": "VoiceMessageRecorder.module__timer___TEU5b2",
  "ou": "VoiceMessageRecorder.module__waveform___TEU5b2",
  "hd": "VoiceMessageRecorder.module__waveformBar___TEU5b2",
  "gb": "VoiceMessageRecorder.module__iconButton___TEU5b2",
  "T5": "VoiceMessageRecorder.module__trashButton___TEU5b2",
  "jo": "VoiceMessageRecorder.module__sendButton___TEU5b2",
  "QO": "VoiceMessageRecorder.module__lockIndicatorWrapper___TEU5b2",
  "zY": "VoiceMessageRecorder.module__lockIndicator___TEU5b2",
  "bd": "VoiceMessageRecorder.module__lockIndicatorLocked___TEU5b2",
  "GR": "VoiceMessageRecorder.module__lockIndicatorIcon___TEU5b2",
  "c8": "VoiceMessageRecorder.module__lockIndicatorCaret___TEU5b2",
};

module.exports = exports;
